<app-modal-header>
  <div class="flex">
    <h1 translate class="ml-2 flex items-center text-xl font-medium text-base-ea-700">zoom.minhas-lives</h1>
  </div>
</app-modal-header>
<div app-modal-content class="h-[75vh] w-[70vw] p-0!">
  @if (loading()) {
    <app-skeleton></app-skeleton>
  } @else if (livesZoom.length > 0 || livesMeet.length > 0 || livesJitsi.length > 0) {
    <app-sidenav-group class="h-full w-full">
      <ng-template app-sidenav-outer>
        <div class="flex w-full flex-col gap-4 px-5 py-8">
          @for (live of livesZoom; track live.id) {
            <a
              class="flex cursor-pointer items-center justify-between rounded-xl rounded-l-md border-l-4 border-base-zoom-500 bg-base-zoom-100 px-5 py-3 shadow shadow-base-gray-300/40 transition duration-300 hover:bg-base-zoom-200"
            >
              <div class="info-left flex items-center gap-8">
                <div>
                  <div
                    class="flex h-[40px] w-[40px] flex-col items-center justify-center rounded-full shadow-inner shadow-base-gray-200"
                  >
                    <span class="flex flex-col items-center justify-center rounded-full bg-white p-2 shadow-inner">
                      <svg-icon [src]="'icon-zoom' | icon"></svg-icon>
                    </span>
                  </div>
                </div>
                <div class="flex flex-col gap-1">
                  <h1 class="text-md font-medium text-zinc-900 first-letter:uppercase">
                    {{ live.descricao }}
                    <span class="ml-1 text-sm font-normal text-zinc-500">({{ live.codigo }})</span>
                  </h1>
                </div>
              </div>
              <div class="flex items-center justify-center gap-8">
                <div (click)="openHall(live)" app-tooltip [tooltip]="'zoom.ir-sala' | translate" class="flex w-6">
                  <svg-icon
                    class="w-full text-base-zoom-500 hover:text-base-zoom-400"
                    [src]="'icon-play-fill' | icon"
                  ></svg-icon>
                </div>
                <div
                  class="flex w-10 transition duration-300"
                  app-tooltip
                  [tooltip]="'zoom.gravacoes' | translate"
                  (click)="onLoadRecords(live.turma_id, live.codigo)"
                >
                  <svg-icon
                    class="w-full text-base-zoom-500 hover:text-base-zoom-400"
                    [src]="'icon-video' | icon"
                  ></svg-icon>
                </div>
              </div>
            </a>
          }
          @for (live of livesMeet; track live.id) {
            <a
              class="flex cursor-pointer items-center justify-between rounded-xl rounded-l-md border-l-4 border-base-hangout-meet-500 bg-base-hangout-meet-100 px-5 py-3 shadow shadow-base-gray-300/40 transition duration-300 hover:bg-base-hangout-meet-200"
            >
              <div class="info-left flex items-center gap-8">
                <div>
                  <div
                    class="flex h-[40px] w-[40px] flex-col items-center justify-center rounded-full shadow-inner shadow-base-gray-200"
                  >
                    <span class="flex flex-col items-center justify-center rounded-full bg-white p-2 shadow-inner">
                      <svg-icon src="assets/images/brands/icon-meet.svg"></svg-icon>
                    </span>
                  </div>
                </div>
                <div class="flex flex-row gap-2">
                  @if (!!live.pin) {
                    <svg-icon class="flex w-6 text-base-hangout-meet-600" [src]="'icon-pin' | icon"></svg-icon>
                  }
                  <h1 class="text-md font-medium text-zinc-900 first-letter:uppercase">
                    {{ live.title }}
                    <span class="ml-1 text-md font-normal text-zinc-600">({{ live?.subject?.descricao }})</span>
                  </h1>
                </div>
              </div>
              <div (click)="openLive(live.link)" class="flex w-6" app-tooltip [tooltip]="'zoom.ir-sala' | translate">
                <svg-icon
                  class="w-full text-base-hangout-meet-500 hover:text-base-hangout-meet-400"
                  [src]="'icon-play-fine' | icon"
                ></svg-icon>
              </div>
            </a>
          }
          @for (live of livesJitsi; track live.id) {
            <a
              class="flex cursor-pointer items-center justify-between rounded-xl rounded-l-md border-l-4 border-theme-600 bg-theme-100 px-5 py-3 shadow shadow-base-gray-300/40 transition duration-300 hover:bg-theme-200"
            >
              <div class="info-left flex items-center gap-8">
                <div>
                  <div
                    class="flex h-[40px] w-[40px] flex-col items-center justify-center rounded-full shadow-inner shadow-base-gray-200"
                  >
                    <span class="flex flex-col items-center justify-center rounded-full bg-white p-2 shadow-inner">
                      <svg-icon class="flex h-8 w-8 text-theme-600" [src]="'icon-video' | icon"></svg-icon>
                    </span>
                  </div>
                </div>
                <div class="flex flex-col gap-1">
                  <h1 class="text-md font-medium text-zinc-900 first-letter:uppercase">
                    {{ live.descricao }}
                    <span class="ml-1 text-sm font-normal text-zinc-500">({{ live.codigo }})</span>
                  </h1>
                </div>
              </div>
              <div class="flex flex-row gap-8 justify-center items-center">
                <div
                  (click)="onLoadRecordingsJitsi(live)"
                  class="flex w-10"
                  app-tooltip
                  [tooltip]="'zoom.gravacao' | translate"
                >
                  <svg-icon class="w-full text-theme-600 hover:text-theme-500" [src]="'icon-video' | icon"></svg-icon>
                </div>
                <div (click)="openLive(live.link)" class="flex w-6" app-tooltip [tooltip]="'zoom.ir-sala' | translate">
                  <svg-icon
                    class="w-full text-base-status-success-600 hover:text-base-status-success-600"
                    [src]="'icon-play-fine' | icon"
                  ></svg-icon>
                </div>
              </div>
            </a>
          }
        </div>
      </ng-template>
    </app-sidenav-group>
  } @else {
    <app-jumbotron class="h-full">
      {{ 'zoom.nenhuma-sala' | translate }}
    </app-jumbotron>
  }
</div>
